/**
 * GrupoLocalRepository
 *
 * Abstrai o acesso aos grupos de produto armazenados localmente via Electron IPC.
 */
import { getElectronAPI } from "@/plugins/desktop";

const GrupoLocalRepository = {
  _api() {
    return getElectronAPI();
  },

  async listar() {
    return this._api().grupos.listar();
  },

  async buscar(termo) {
    return this._api().grupos.buscar(termo);
  },

  async salvar(items) {
    return this._api().grupos.salvar(items);
  },

  async buscarPorId(id) {
    return this._api().grupos.buscarPorId(id);
  },

  async contar() {
    return this._api().grupos.contar();
  },
};

export default GrupoLocalRepository;
